import React from "react";
import {BrowserRouter} from "react-router-dom";
import "./App.scss";
import "./contexts/LoadingContext.scss";
import Main from "./containers/Main";
import ErrorBoundary from "@app/ErrorBoundary";
import {AuthProvider} from "./contexts/AuthContext";
import {SettingsProvider} from "./contexts/SettingsContext";
import {PortfolioProvider} from "./contexts/PortfolioContext";
import {LoadingProvider} from "./contexts/LoadingContext";
import {ToastProvider} from "./contexts/ToastContext";

function App() {
  return (
    <ErrorBoundary>
      <BrowserRouter>
        <ToastProvider>
          <LoadingProvider>
            <AuthProvider>
              <SettingsProvider>
                <PortfolioProvider>
                  <div>
                    <Main />
                  </div>
                </PortfolioProvider>
              </SettingsProvider>
            </AuthProvider>
          </LoadingProvider>
        </ToastProvider>
      </BrowserRouter>
    </ErrorBoundary>
  );
}

export default App;
